(function () {
  'use strict';
  var E = window.ELVI = window.ELVI || {};
  E.root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  E.types = [['overhead', 'Overhead'], ['wall', 'Wall lights'], ['standing', 'Table & floor lights'], ['outdoor', 'Outdoor']];
  E.rooms = [
    ['living', 'Living room', 'Layered, warm evening light'],
    ['bedroom', 'Bedroom', 'Soft and restful'],
    ['dining', 'Dining & kitchen', 'Over the table and island'],
    ['hall', 'Hallway & stairs', 'Welcome and wayfinding'],
    ['outdoor', 'Outdoor & garden', 'Paths, walls and terraces']
  ];
  E.moods = [
    ['natural', 'Soft & natural', 'Wood, rattan, ceramic'],
    ['polished', 'Polished & luminous', 'Glass, brass, metal'],
    ['stone', 'Sculptural & stone', 'Marble, travertine, stone']
  ];
  var ROOMS = {
    pendant: ['dining', 'living', 'hall'], ceiling: ['living', 'bedroom', 'hall', 'dining'],
    wall: ['living', 'bedroom', 'hall', 'dining'], floor: ['living', 'bedroom'],
    table: ['bedroom', 'living', 'dining'], outdoor: ['outdoor']
  };
  var MAT = {
    natural: /wood|walnut|oak|rattan|bamboo|wicker|cane|jute|linen|paper|ceramic|porcelain|hand-?painted|terracotta|clay/g,
    polished: /glass|opal|murano|crystal|brass|gold|bronze|chrome|metal|steel|copper|iron/g,
    stone: /marble|travertine|stone|terrazzo|alabaster|onyx|concrete|plaster/g
  };

  /* New random salt on every page load: order of pieces and the photo shown for each piece change on refresh */
  E.salt = String(Math.floor(Math.random() * 1e9));

  E.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  E.hash = function (s) {
    s = s + E.salt;
    var h = 0, i;
    for (i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
    h = Math.imul(h ^ (h >>> 15), 2246822507); h = Math.imul(h ^ (h >>> 13), 3266489909);
    return Math.abs(h ^ (h >>> 16));
  };
  E.money = function (n) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || E.currency || 'GBP';
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur, minimumFractionDigits: n % 1 === 0 ? 0 : 2 }).format(n); }
    catch (e) { return n.toFixed(2); }
  };
  E.img = function (src, w) { return src ? src.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2') : src; };
  E.cover = function (p) { return E.hash(p.handle + 'cover') % p.images.length; };
  /* Quiz results use the variant photos (grey background) only */
  E.quizImg = function (p) { return p.vimgs.length ? p.vimgs[E.hash(p.handle + 'q') % p.vimgs.length] : p.first; };

  function count(re, s) { var m = s.match(re); return m ? m.length : 0; }

  function build(p) {
    if (!p.images || !p.images.length || !p.variants || !p.variants.length) return null;
    var vimg = {};
    p.variants.forEach(function (v) { if (v.featured_image && v.featured_image.id) vimg[v.featured_image.id] = 1; });
    function isVar(i) { return !!(vimg[i.id] || (i.variant_ids && i.variant_ids.length)); }
    function map(i) { return { src: i.src, w: i.width || 800, h: i.height || 1000 }; }
    /* Gallery: skip the first photo (grey packshot) and any variant photo */
    var imgs = p.images.filter(function (i, idx) { return idx > 0 && !isVar(i); }).map(map);
    var vimgs = p.images.filter(isVar).map(map);
    var gal = imgs.length > 0;
    if (!gal && !vimgs.length) return null;
    var head = (p.title + ' ' + (p.product_type || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
    var g, sub;
    if (/outdoor|solar|garden|pathway|bollard|landscape|patio/.test(head)) { g = 'outdoor'; sub = 'outdoor'; }
    else if (/wall|sconce/.test(head)) { g = 'wall'; sub = 'wall'; }
    else if (/pendant|chandelier/.test(head)) { g = 'overhead'; sub = 'pendant'; }
    else if (/ceiling|flush|spot ?light/.test(head)) { g = 'overhead'; sub = 'ceiling'; }
    else if (/floor|standing/.test(head)) { g = 'standing'; sub = 'floor'; }
    else { g = 'standing'; sub = 'table'; }
    var body = (p.body_html || '').replace(/<[^>]*>/g, ' ').toLowerCase();
    var moods = [];
    E.moods.forEach(function (m) { if (count(MAT[m[0]], head) * 3 + count(MAT[m[0]], body) >= 2) moods.push(m[0]); });
    var variants = p.variants.map(function (v) {
      return {
        id: v.id, title: v.title, price: parseFloat(v.price) || 0, compare: parseFloat(v.compare_at_price) || 0,
        available: v.available !== false, img: ''
      };
    });
    var low = variants.reduce(function (a, b) { return b.price < a.price ? b : a; });
    return {
      id: p.id, handle: p.handle, title: p.title, g: g, sub: sub, rooms: ROOMS[sub], moods: moods, gal: gal,
      images: gal ? imgs : vimgs, vimgs: vimgs, first: map(p.images[0]),
      variants: variants, price: low.price, compare: low.compare > low.price ? low.compare : 0,
      from: variants.some(function (v) { return v.price !== low.price; }),
      url: E.root + 'products/' + p.handle
    };
  }

  E.load = function () {
    if (E._p) return E._p;
    function page(n, acc) {
      return fetch(E.root + 'products.json?limit=250&page=' + n).then(function (r) {
        if (!r.ok) throw new Error('products');
        return r.json();
      }).then(function (j) {
        var l = j.products || [], all = acc.concat(l);
        return l.length === 250 && n < 8 ? page(n + 1, all) : all;
      });
    }
    E._p = page(1, []).then(function (list) {
      E.all = list.map(build).filter(Boolean);
      E.products = E.all.filter(function (p) { return p.gal; });
      return E.products;
    });
    return E._p;
  };

  E.recommend = function (s) {
    var all = E.all || [], note = '';
    function roomOk(p) { return s.room === 'any' || p.rooms.indexOf(s.room) > -1; }
    function typeOk(p) { return !s.type || s.type === 'any' || p.g === s.type; }
    function score(p) {
      var sc = Math.min(p.images.length, 6) * 0.2;
      if (s.mood && s.mood !== 'any' && p.moods.indexOf(s.mood) > -1) sc += 3;
      return sc;
    }
    var pool = all.filter(function (p) { return roomOk(p) && typeOk(p); });
    if (pool.length < 3) { pool = all.filter(roomOk); note = 'No exact match, so here is the closest.'; }
    if (pool.length < 3) { pool = all.slice(); note = 'Here is a selection to start from.'; }
    pool.sort(function (a, b) { return score(b) - score(a) || E.hash(a.handle) - E.hash(b.handle); });
    return { list: pool.slice(0, 6), note: note };
  };

  E.initQuiz = function (box) {
    var st = { i: 0, a: {} };
    var steps = [
      { k: 'room', q: 'Which room are you lighting?', o: E.rooms },
      { k: 'mood', q: 'Which mood speaks to you?', o: E.moods.concat([['any', 'Surprise me', 'Show me everything']]) },
      { k: 'type', q: 'What kind of light do you need?', o: [
        ['overhead', 'Overhead', 'Pendants and ceiling lights'], ['wall', 'Wall glow', 'Sconces and wall lights'],
        ['standing', 'To place', 'Table and floor lights'], ['any', 'Not sure yet', 'Show me a mix']] }
    ];
    function total() { return st.a.room === 'outdoor' ? 2 : 3; }
    function label(list, v) { var r = list.filter(function (x) { return x[0] === v; })[0]; return r ? r[1] : ''; }

    function renderStep() {
      var s = steps[st.i], h = '';
      h += '<div class="elvi-q" data-step="' + st.i + '"><p class="elvi-q__step">Question ' + (st.i + 1) + ' of ' + total() + '</p>';
      h += '<h2 class="elvi-q__title">' + s.q + '</h2><div class="elvi-opts">';
      s.o.forEach(function (o) {
        h += '<button type="button" class="elvi-opt" data-v="' + o[0] + '"><b>' + o[1] + '</b><small>' + (o[2] || '') + '</small></button>';
      });
      h += '</div>' + (st.i > 0 ? '<button type="button" class="elvi-link" data-back>Back</button>' : '') + '</div>';
      box.innerHTML = h;
    }

    function card(p, i) {
      var c = E.quizImg(p);
      return '<button type="button" class="elvi-rc" data-h="' + E.esc(p.handle) + '" style="--i:' + i + '"><span class="elvi-rc__img"><img src="' + E.esc(E.img(c.src, 520)) +
        '" alt="' + E.esc(p.title) + '" loading="lazy"></span><span class="elvi-rc__txt"><span class="elvi-rc__name">' + E.esc(p.title) +
        '</span><span class="elvi-rc__price">' + (p.from ? 'From ' : '') + E.money(p.price) + '</span></span></button>';
    }

    function showResults() {
      box.innerHTML = '<div class="elvi-q"><p class="elvi-q__step">Lighting your selection</p><div class="elvi-wait"><span></span><span></span><span></span></div></div>';
      var t0 = Date.now();
      E.load().then(function () {
        var wait = Math.max(0, 900 - (Date.now() - t0));
        setTimeout(function () { renderResults(); }, wait);
      }).catch(function () {
        box.innerHTML = '<div class="elvi-q"><h2 class="elvi-q__title">We could not load the collection just now.</h2><a class="elvi-btn" href="' + E.root + 'collections/all">Browse every piece</a></div>';
      });
    }

    function renderResults() {
      var r = E.recommend(st.a), parts = [label(E.rooms, st.a.room)];
      if (st.a.mood && st.a.mood !== 'any') parts.push(label(E.moods, st.a.mood));
      if (st.a.type && st.a.type !== 'any') parts.push(label(E.types, st.a.type));
      var h = '<div class="elvi-res"><p class="elvi-q__step">Selected for ' + E.esc(parts.join(' · ')) + '</p><h2 class="elvi-q__title">Your light edit</h2>';
      if (r.note) h += '<p class="elvi-note">' + r.note + '</p>';
      h += '<div class="elvi-res__grid">' + r.list.map(card).join('') + '</div>';
      h += '<div class="elvi-res__act"><button type="button" class="elvi-btn elvi-btn--solid" data-all>See every match below</button><button type="button" class="elvi-btn" data-restart>Start again</button></div></div>';
      box.innerHTML = h;
    }

    box.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !box.contains(t)) return;
      if (t.hasAttribute('data-v')) {
        st.a[steps[st.i].k] = t.getAttribute('data-v');
        if (steps[st.i].k === 'room' && st.a.room === 'outdoor') { st.a.mood = st.a.mood || 'any'; st.i = 1; }
        else st.i++;
        if (st.a.room === 'outdoor' && st.i >= 2) { st.a.type = 'outdoor'; showResults(); return; }
        if (st.i >= steps.length) { showResults(); return; }
        renderStep();
      } else if (t.hasAttribute('data-back')) {
        st.i = Math.max(0, st.i - 1); renderStep();
      } else if (t.hasAttribute('data-restart')) {
        st = { i: 0, a: {} }; renderStep();
      } else if (t.hasAttribute('data-all')) {
        E.setFilters({
          type: st.a.type && st.a.type !== 'any' ? st.a.type : 'all', room: st.a.room || 'all',
          mood: st.a.mood && st.a.mood !== 'any' ? st.a.mood : 'all'
        });
        var g = document.getElementById('elvi-gallery');
        if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (t.hasAttribute('data-h')) {
        var h = t.getAttribute('data-h'), p = (E.all || []).filter(function (x) { return x.handle === h; })[0];
        if (p && E.open) E.open(p, E.cover(p));
      }
    });
    renderStep();
    E.load().catch(function () {});
  };
})();